var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChatBotError(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 375,
    height: 256,
    viewBox: "0 0 375 256",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 11"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "M194.93 68.0145C153.47 -44.5027 97.0275 -17.2301 88.5 149.883C86.2563 193.853 128.534 227.648 186.5 229C244.466 230.352 292.963 200.734 293.991 156.726C295.019 112.718 210.605 110.555 194.93 68.0145Z",
    fill: "url(#paint0_linear)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 155.968,
    y: 110.923,
    width: 4,
    height: 14,
    rx: 2,
    transform: "rotate(-40 155.968 110.923)",
    fill: "#D8D8D8"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 9"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 36"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    d: "M317.342 208.519C316.782 208.42 316.211 208.516 315.649 208.773C314.891 205.106 313.171 202.532 310.802 202.114C308.434 201.696 305.937 203.527 303.971 206.713C303.531 206.28 303.027 205.995 302.467 205.896C299.776 205.422 296.83 209.37 295.888 214.715L320.508 219.057C321.45 213.711 320.033 208.994 317.342 208.519Z",
    fill: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    d: "M87.4518 204.136C87.02 204.251 86.6314 204.479 86.3428 204.785C84.7617 202.789 82.8222 201.736 81.0485 202.178C79.2747 202.62 78.0565 204.461 77.5979 206.966C77.1991 206.831 76.749 206.812 76.3136 206.913C74.2985 207.415 73.3745 210.668 74.2499 214.179L92.6855 209.583C91.8101 206.072 89.4669 203.633 87.4518 204.136Z",
    fill: "#D4D4D4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M374.877 255.291H0.625294C0.962497 224.884 84.6149 200.264 187.751 200.264C290.887 200.264 374.54 224.884 374.877 255.291Z",
    fill: "url(#paint1_radial)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 2",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path 11",
    d: "M42.8485 213.659C42.8485 213.659 49.9866 212.946 50.6865 207.322",
    stroke: "#D5D3D3",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Oval Copy",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.3864 207.636C54.0516 207.636 56.2121 205.476 56.2121 202.811C56.2121 200.145 54.0516 197.985 51.3864 197.985C48.7212 197.985 46.5606 200.145 46.5606 202.811C46.5606 205.476 48.7212 207.636 51.3864 207.636Z",
    fill: "url(#paint2_radial)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 12",
    d: "M42.8485 201.301L42.6629 220.629",
    stroke: "#D5D3D3",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Oval",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.8485 201.697C51.0491 201.697 57.697 195.049 57.697 186.848C57.697 178.648 51.0491 172 42.8485 172C34.6479 172 28 178.648 28 186.848C28 195.049 34.6479 201.697 42.8485 201.697Z",
    fill: "url(#paint3_radial)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 2 Copy",
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path 11_2",
    d: "M330 205C330 205 345.482 203.426 347 191",
    stroke: "#D5D3D3",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Oval Copy_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M348.5 192C354.299 192 359 187.075 359 181C359 174.925 354.299 170 348.5 170C342.701 170 338 174.925 338 181C338 187.075 342.701 192 348.5 192Z",
    fill: "url(#paint4_radial)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 12_2",
    d: "M329.75 177L329.25 220",
    stroke: "#D5D3D3",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Oval_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M329 178C347.225 178 362 163.225 362 145C362 126.775 347.225 112 329 112C310.775 112 296 126.775 296 145C296 163.225 310.775 178 329 178Z",
    fill: "url(#paint5_radial)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 8"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle Copy 7",
    x: 154.412,
    y: 73.8661,
    width: 63.5387,
    height: 124.634,
    rx: 8,
    fill: "url(#paint6_linear)",
    stroke: "#585858",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Oval_3",
    opacity: 0.6,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M187 202C208.539 202 226 201.328 226 200.5C226 199.672 208.539 199 187 199C165.461 199 148 199.672 148 200.5C148 201.328 165.461 202 187 202Z",
    fill: "#D8D8D8"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 22"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2",
    x: 177.584,
    y: 138.868,
    width: 3.05474,
    height: 4.92973,
    rx: 1.52737,
    fill: "#C9C9C9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle Copy 10",
    x: 182.472,
    y: 135.582,
    width: 3.05474,
    height: 8.21621,
    rx: 1.52737,
    fill: "#C9C9C9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle Copy 11",
    x: 187.359,
    y: 131.748,
    width: 3.05474,
    height: 12.0504,
    rx: 1.52737,
    fill: "#C9C9C9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle Copy 22",
    x: 192.247,
    y: 127.913,
    width: 3.05474,
    height: 15.8847,
    rx: 1.52737,
    fill: "#C9C9C9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 15 Copy 3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Oval_4",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M186.137 135.856C190.186 135.856 193.469 132.573 193.469 128.524C193.469 124.475 190.186 121.193 186.137 121.193C182.088 121.193 178.806 124.475 178.806 128.524C178.806 132.573 182.088 135.856 186.137 135.856Z",
    fill: "#C81E1E",
    stroke: "#F3F3F3",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3",
    x: 185.526,
    y: 124.248,
    width: 1.2219,
    height: 5.49854,
    rx: 0.610949,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle Copy 6",
    x: 185.526,
    y: 131.579,
    width: 1.2219,
    height: 1.2219,
    rx: 0.610949,
    fill: "white"
  })))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 9.19048,
    y1: 117.671,
    x2: 173.392,
    y2: 276.466,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAFAFA",
    stopOpacity: 0.556818
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5F5F5"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(236.535 239.089) rotate(-168.312) scale(162.92 64.9828)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFBFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E2E2E2"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(49.5363 200.934) rotate(-125.402) scale(7.10217 6.74266)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFBFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E2E2E2"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(50.3625 199.216) rotate(-125.402) scale(21.8528 20.7466)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFBFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E2E2E2"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(344.475 176.722) rotate(-124.154) scale(15.9458 14.8946)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFBFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E2E2E2"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(345.7 172.487) rotate(-125.402) scale(48.5668 46.1083)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFBFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E2E2E2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear",
    x1: 178.669,
    y1: 50.4723,
    x2: 105.597,
    y2: 129.111,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8E8E8"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatBotError);
export default __webpack_public_path__ + "static/media/chat-bot-error.bb48a2dc8a4124aae2bf52b77199194f.svg";
export { ForwardRef as ReactComponent };